<template>
  <div>
    <div class="main-title">客户端版本管理</div>
    <el-row class="content-container">
      <div class="table-container">
        <div class="btn-container">
          <el-button type="primary" @click="addClient">新增</el-button>
        </div>
        <el-table :data="clientEditionList" style="width: 100%">
          <el-table-column type="index" label="序号" />
          <el-table-column prop="edition_title" label="标题" />
          <el-table-column prop="version_number" label="版本号" />
          <el-table-column prop="create_user_id" label="创建人" />
          <el-table-column prop="update_user_id" label="修改人" />
          <el-table-column prop="in_use_text" label="有效状态" />
          <el-table-column prop="create_time" label="创建时间" />
          <el-table-column prop="update_time" label="修改时间" />
          <el-table-column label="操作">
            <template slot-scope="scope">
              <el-button type="text" @click="updateClient(scope.row)"
                >编辑</el-button
              >
              <el-button type="text" @click="deleteClient(scope.row)"
                >删除</el-button
              >
            </template>
          </el-table-column>
        </el-table>
        <el-pagination
          class="pagination"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
          :current-page.sync="currentPage"
          :page-size="pageSize"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
        />
      </div>
    </el-row>
    <el-dialog title="" :visible.sync="dialogVisible">
      <el-form label-width="90px" :rules="rules" ref="formRule" :model="config">
        <el-row>
          <el-col :span="11">
            <el-form-item label="版本标题:">
              <el-input
                v-model="config.editionTitle"
                placeholder="请输入版本标题"
              />
            </el-form-item>
          </el-col>
          <el-col :span="11" :offset="2">
            <el-form-item label="版本号:" prop="versionNumber">
              <el-input
                v-model="config.versionNumber"
                placeholder="请输入版本号"
              />
            </el-form-item>
          </el-col>
          <el-col :span="11">
            <el-form-item label="有效标志:" prop="inUse">
              <el-select v-model="config.inUse">
                <el-option value="1" label="有效" />
                <el-option value="0" label="无效" />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="版本描述:">
              <el-input
                type="textarea"
                :rows="4"
                v-model="config.editionDescription"
                placeholder="请输入版本描述"
              />
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div slot="footer">
        <el-upload
          action=""
          :http-request="fileUpload"
          :show-file-list="false"
          class="file-upload"
        >
          <el-button type="primary">选择文件</el-button>
        </el-upload>
        <el-button type="primary" @click="submit">确 定</el-button>
        <el-button type="primary" @click="dialogVisible = false"
          >取 消</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>

<script>
import paginationMixin from 'mixin/pagination';

export default {
  data() {
    return {
      clientId: '',
      clientEditionList: [],
      dialogTitle: '新增版本',
      fileUrl: '',
      dialogVisible: false,
      config: {
        editionTitle: '',
        versionNumber: '',
        inUse: '1',
        editionDescription: ''
      },
      rules: {
        versionNumber: [
          { required: true, message: '请输入版本号', trigger: 'blur' }
        ],
        inUse: [{ required: true, message: '选择有效标志', trigger: 'blur' }]
      }
    };
  },
  mixins: [paginationMixin],
  mounted() {
    this.querySubmit();
  },
  methods: {
    querySubmit() {
      this.$request({
        url: '/rest/statistic/reportData',
        data: {
          json: JSON.stringify({
            pageBean: {
              pageNum: this.currentPage,
              pageSize: this.pageSize
            },
            params: {
              handlerName: 'client_exe_version_list'
            }
          })
        }
      }).then(res => {
        this.clientEditionList = res.list.map(item => ({
          ...item,
          in_use_text: item.in_use === '1' ? '有效' : '无效'
        }));
        this.total = res.total || 0;
      });
    },
    addClient() {
      this.dialogVisible = true;
      this.config = {
        editionTitle: '',
        versionNumber: '',
        inUse: '',
        editionDescription: ''
      };
    },
    fileUpload(params) {
      const { file } = params;
      const fd = new FormData();
      fd.append('file', file);
      this.$request({
        isFileRequest: true,
        url: 'open/clientVersion/uploadClientExe',
        data: fd
      }).then(res => {
        this.fileUrl = res.fileUrl;
      });
    },
    updateClient(row) {
      this.config = {
        editionTitle: row.edition_title,
        versionNumber: row.version_number,
        inUse: row.in_use,
        editionDescription: row.edition_description
      };
      this.fileUrl = row.file_url;
      this.clientId = row.id;
      this.dialogVisible = true;
    },
    submit() {
      if (!this.fileUrl) {
        this.$alert('请选择上传文件');
        return;
      }
      this.$refs.formRule.validate(valid => {
        if (valid) {
          this.$request({
            url: 'rest/clientVersion/mergerClientExeVersion',
            data: {
              json: JSON.stringify({
                params: {
                  clientExeInfo: {
                    ...this.config,
                    fileUrl: this.fileUrl,
                    id: this.clientId
                  }
                }
              })
            }
          }).then(res => {
            if (this.clientId) {
              this.$alert('编辑版本成功');
            } else {
              this.$alert('新增版本成功');
            }
            this.dialogVisible = false;
            this.querySubmit();
          });
        }
      });
    },
    deleteClient(row) {
      this.$request({
        url: 'rest/clientVersion/delClientExeVersion',
        data: {
          json: JSON.stringify({
            params: {
              delIds: row.id
            }
          })
        }
      }).then(res => {
        this.$alert('删除成功');
        this.querySubmit();
      });
    }
  }
};
</script>

<style lang="stylus" scoped>
@import './common.styl'
.btn-container
  text-align left
  padding 20px
.file-upload
  display inline-block
.pagination
  padding 20px
  background #fff
  text-align right
</style>
